import { render, staticRenderFns } from "./ItemPage.vue?vue&type=template&id=4d21abba&scoped=true&"
import script from "./ItemPage.vue?vue&type=script&lang=js&"
export * from "./ItemPage.vue?vue&type=script&lang=js&"
import style0 from "./ItemPage.vue?vue&type=style&index=0&id=4d21abba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d21abba",
  null
  
)

export default component.exports